exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-common-import .submit-button{margin-top:15px}", ""]);

// exports
